import gql from 'graphql-tag';

export const UPLOAD_STAGE_DOCUMENT = gql`
  mutation UploadStageDocument($input: UploadStageDocumentInput!) {
    bpf {
      result: uploadStageDocument(input: $input) {
        error
        success
        entity {
          id
        }
      }
    }
  }
`;
